/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { ISecurityRequirementParent } from '../../core/models/common/ISecurityRequirementParent';
import { Operation } from '../../core/models/common/Operation';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';
import { IOasParameterParent } from './IOasParameterParent';
import { OasParameter } from './OasParameter';
import { OasResponses } from './OasResponses';
import { OasSecurityRequirement } from './OasSecurityRequirement';

/**
 * Constructor.
 * @param {string} method
 * @class
 * @extends Operation
 * @author eric.wittmann@gmail.com
 */
export abstract class OasOperation extends Operation implements IOasParameterParent, ISecurityRequirementParent {
    public tags : Array<string>;

    public parameters : Array<OasParameter>;

    public responses : OasResponses;

    public deprecated : boolean;

    public security : Array<SecurityRequirement>;

    public constructor(method : string) {
        super(method);
        if(this.tags===undefined) this.tags = null;
        if(this.parameters===undefined) this.parameters = null;
        if(this.responses===undefined) this.responses = null;
        if(this.deprecated===undefined) this.deprecated = null;
        if(this.security===undefined) this.security = null;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.IOasParameterParent#getParameters()
     * @return {OasParameter[]}
     */
    public getParameters() : Array<OasParameter> {
        return this.parameters;
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.IOasParameterParent#getParametersIn(java.lang.String)
     * @param {string} in
     * @return {OasParameter[]}
     */
    public getParametersIn(__in : string) : Array<OasParameter> {
        let params : Array<OasParameter> = <any>([]);
        if(!NodeCompat.isNullOrUndefined(this.parameters)) {
            this.parameters.forEach(((params) => {
                return (param) => {
                    if(NodeCompat.equals(param.in, __in)) {
                        /* add */(params.push(param)>0);
                    }
                }
            })(params));
        }
        return params;
    }

    /**
     * Gets the operation's method.
     * @return {string}
     */
    public getMethod() : string {
        return this.getType();
    }

    /**
     * Creates a child parameter model.
     * @return {OasParameter}
     */
    public abstract createParameter() : OasParameter;

    /**
     * Returns a single, unique parameter identified by "in" and "name" (which are the two
     * properties that uniquely identify a parameter).  Returns null if no parameter is found.
     * @param {string} in
     * @param {string} name
     * @return {OasParameter}
     */
    public getParameter(__in : string, name : string) : OasParameter {
        let rval : OasParameter = null;
        if(this.parameters != null) {
            for(let index251=0; index251 < this.parameters.length; index251++) {
                let parameter = this.parameters[index251];
                {
                    if(NodeCompat.equals(parameter.in, __in) && NodeCompat.equals(parameter.name, name)) {
                        rval = parameter;
                    }
                }
            }
        }
        return rval;
    }

    /**
     * Adds a parameter.
     * @param {OasParameter} parameter
     * @return {OasParameter}
     */
    public addParameter(parameter : OasParameter) : OasParameter {
        if(this.parameters == null) {
            this.parameters = <any>([]);
        }
        /* add */(this.parameters.push(parameter)>0);
        return parameter;
    }

    /**
     * Creates a child responses model.
     * @return {OasResponses}
     */
    public abstract createResponses() : OasResponses;

    /**
     * @see io.apicurio.datamodels.core.models.common.ISecurityRequirementParent#createSecurityRequirement()
     * @return {OasSecurityRequirement}
     */
    public abstract createSecurityRequirement() : OasSecurityRequirement;

    /**
     * @see io.apicurio.datamodels.core.models.common.ISecurityRequirementParent#addSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} securityRequirement
     * @return {SecurityRequirement}
     */
    public addSecurityRequirement(securityRequirement : SecurityRequirement) : SecurityRequirement {
        if(this.security == null) {
            this.security = <any>([]);
        }
        /* add */(this.security.push(securityRequirement)>0);
        return securityRequirement;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.ISecurityRequirementParent#getSecurityRequirements()
     * @return {SecurityRequirement[]}
     */
    public getSecurityRequirements() : Array<SecurityRequirement> {
        return this.security;
    }
}
OasOperation["__class"] = "io.apicurio.datamodels.openapi.models.OasOperation";
OasOperation["__interfaces"] = ["io.apicurio.datamodels.core.models.common.ISecurityRequirementParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.openapi.models.IOasParameterParent","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];




